(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-new"] && !Shopify.designMode) return;
  try {
    
 $('.feature-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 2,
 	arrows: true,
    prevArrow: '<div class="slide-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M10.0875 15.6789L20.5369 25.6351C20.7112 25.8013 20.9429 25.894 21.1838 25.894C21.4246 25.894 21.6563 25.8013 21.8306 25.6351L21.8419 25.6239C21.9267 25.5433 21.9942 25.4463 22.0404 25.3388C22.0865 25.2313 22.1103 25.1155 22.1103 24.9986C22.1103 24.8816 22.0865 24.7658 22.0404 24.6583C21.9942 24.5508 21.9267 24.4538 21.8419 24.3732L12.0019 14.9982L21.8419 5.62699C21.9267 5.54641 21.9942 5.44943 22.0404 5.34193C22.0865 5.23443 22.1103 5.11866 22.1103 5.00168C22.1103 4.88469 22.0865 4.76892 22.0404 4.66143C21.9942 4.55393 21.9267 4.45694 21.8419 4.37636L21.8306 4.36511C21.6563 4.1989 21.4246 4.10618 21.1838 4.10618C20.9429 4.10618 20.7112 4.1989 20.5369 4.36511L10.0875 14.3214C9.99561 14.4089 9.92245 14.5142 9.87246 14.6309C9.82247 14.7476 9.79669 14.8732 9.79669 15.0001C9.79669 15.127 9.82247 15.2527 9.87246 15.3693C9.92245 15.486 9.99561 15.5913 10.0875 15.6789Z" fill="black"/></svg></div>',
    nextArrow: '<div class="slide-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M19.9126 14.3211L9.46318 4.36489C9.28883 4.19868 9.05719 4.10596 8.81631 4.10596C8.57542 4.10596 8.34378 4.19868 8.16943 4.36489L8.15818 4.37614C8.07337 4.45671 8.00583 4.5537 7.95968 4.6612C7.91353 4.7687 7.88973 4.88446 7.88973 5.00145C7.88973 5.11844 7.91353 5.2342 7.95968 5.3417C8.00583 5.4492 8.07337 5.54619 8.15818 5.62676L17.9982 15.0018L8.15818 24.373C8.07337 24.4536 8.00583 24.5506 7.95968 24.6581C7.91353 24.7656 7.88973 24.8813 7.88973 24.9983C7.88973 25.1153 7.91353 25.2311 7.95968 25.3386C8.00583 25.4461 8.07337 25.5431 8.15818 25.6236L8.16943 25.6349C8.34378 25.8011 8.57542 25.8938 8.81631 25.8938C9.05719 25.8938 9.28883 25.8011 9.46318 25.6349L19.9126 15.6786C20.0045 15.5911 20.0776 15.4858 20.1276 15.3691C20.1776 15.2524 20.2034 15.1268 20.2034 14.9999C20.2034 14.873 20.1776 14.7473 20.1276 14.6307C20.0776 14.514 20.0045 14.4087 19.9126 14.3211Z" fill="black"/></svg></div>',   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["releted-product-new"] && !Shopify.designMode) return;
  try {
    
// form a brands slider with slick
$('.releted-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 2,
 	arrows: true,
    prevArrow: '<div class="slide-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M10.0875 15.6789L20.5369 25.6351C20.7112 25.8013 20.9429 25.894 21.1838 25.894C21.4246 25.894 21.6563 25.8013 21.8306 25.6351L21.8419 25.6239C21.9267 25.5433 21.9942 25.4463 22.0404 25.3388C22.0865 25.2313 22.1103 25.1155 22.1103 24.9986C22.1103 24.8816 22.0865 24.7658 22.0404 24.6583C21.9942 24.5508 21.9267 24.4538 21.8419 24.3732L12.0019 14.9982L21.8419 5.62699C21.9267 5.54641 21.9942 5.44943 22.0404 5.34193C22.0865 5.23443 22.1103 5.11866 22.1103 5.00168C22.1103 4.88469 22.0865 4.76892 22.0404 4.66143C21.9942 4.55393 21.9267 4.45694 21.8419 4.37636L21.8306 4.36511C21.6563 4.1989 21.4246 4.10618 21.1838 4.10618C20.9429 4.10618 20.7112 4.1989 20.5369 4.36511L10.0875 14.3214C9.99561 14.4089 9.92245 14.5142 9.87246 14.6309C9.82247 14.7476 9.79669 14.8732 9.79669 15.0001C9.79669 15.127 9.82247 15.2527 9.87246 15.3693C9.92245 15.486 9.99561 15.5913 10.0875 15.6789Z" fill="black"/></svg></div>',
    nextArrow: '<div class="slide-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M19.9126 14.3211L9.46318 4.36489C9.28883 4.19868 9.05719 4.10596 8.81631 4.10596C8.57542 4.10596 8.34378 4.19868 8.16943 4.36489L8.15818 4.37614C8.07337 4.45671 8.00583 4.5537 7.95968 4.6612C7.91353 4.7687 7.88973 4.88446 7.88973 5.00145C7.88973 5.11844 7.91353 5.2342 7.95968 5.3417C8.00583 5.4492 8.07337 5.54619 8.15818 5.62676L17.9982 15.0018L8.15818 24.373C8.07337 24.4536 8.00583 24.5506 7.95968 24.6581C7.91353 24.7656 7.88973 24.8813 7.88973 24.9983C7.88973 25.1153 7.91353 25.2311 7.95968 25.3386C8.00583 25.4461 8.07337 25.5431 8.15818 25.6236L8.16943 25.6349C8.34378 25.8011 8.57542 25.8938 8.81631 25.8938C9.05719 25.8938 9.28883 25.8011 9.46318 25.6349L19.9126 15.6786C20.0045 15.5911 20.0776 15.4858 20.1276 15.3691C20.1776 15.2524 20.2034 15.1268 20.2034 14.9999C20.2034 14.873 20.1776 14.7473 20.1276 14.6307C20.0776 14.514 20.0045 14.4087 19.9126 14.3211Z" fill="black"/></svg></div>',   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();
})();
